import { useFetch } from '@sahinyazilim/sahinyazilim-components';
import { Payment } from 'account/payment/model/payment';
import { commonActions } from 'common/context/CommonSlice';
import { useAppDispatch } from 'common/context/hooks';
import { AdminTablePaths } from 'common/model/AdminTablePaths';
import { useEffect } from 'react';

export const PaymentManager = () => {
  const dispatch = useAppDispatch();

  const { data } = useFetch<Payment[]>(AdminTablePaths.PAYMENT);

  useEffect(() => {
    dispatch(commonActions.setPayments(data));
  }, [data, dispatch]);

  return null;
};
